import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLoyaltyCustomerInfo } from "../../../utils/APICalls/APICalls";
import { LoyaltyCustomerInfoParams } from "../../../utils/loyaltyTypes";

export const fetchLoyaltyCustomerInfo = createAsyncThunk(
  "loyaltyCustomerInfo/fetch",
  async (params: LoyaltyCustomerInfoParams) => {
    const res = await getLoyaltyCustomerInfo(params);

    return res.data;
  }
);
